import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { useGetUserInfo } from "@/hooks/api/useGetUserInfo";
import { needsForceSetPassword } from "@/lib/needsForceSetPassword";

/**
 * 路由守卫：未设密邮箱用户只能访问 /set-password。
 * 判断依据 useGetUserInfo().data（接口轮询），不读 store 中的 userInfo。
 */
export function SetPasswordEnforcer() {
  const navigate = useNavigate();
  const location = useLocation();
  const { data: userInfoFromApi, isFetched } = useGetUserInfo();

  useEffect(() => {
    if (!isFetched) return;

    const mustSetPassword = needsForceSetPassword(userInfoFromApi);

    if (mustSetPassword && location.pathname !== "/set-password") {
      navigate("/set-password", { replace: true });
      return;
    }

    if (!mustSetPassword && location.pathname === "/set-password") {
      navigate("/", { replace: true });
    }
  }, [isFetched, location.pathname, navigate, userInfoFromApi]);

  return null;
}
